var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('device-configuration-templates'),_c('system-statuses'),_c('to-do-templates'),_c('device-settings-templates')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }